"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InfoIcon = undefined;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var InfoIcon = exports.InfoIcon = function InfoIcon() {
  return _react2.default.createElement(
    "svg",
    { width: "20", height: "20", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    _react2.default.createElement("path", {
      d: "M10 1.438C14.729 1.438 18.563 5.272 18.563 10.001C18.563 14.73 14.729 18.564 10 18.564C5.271 18.564 1.437 14.73 1.437 10.001C1.443 5.274 5.273 1.444 9.999 1.438H10ZM10 0C4.477 0 0 4.477 0 10C0 15.523 4.477 20 10 20C15.523 20 20 15.523 20 10C20 4.477 15.523 0 10 0ZM10 6.902C8.977 6.902 8.532 6.477 8.532 5.473C8.532 4.488 8.976 4.063 10 4.063C11.043 4.063 11.468 4.488 11.468 5.473C11.468 6.477 11.043 6.902 10 6.902ZM8.764 15.1777V8.511H11.236V15.1777H8.764Z",
      fill: "#1890FF"
    })
  );
};